module.exports = __webpack_public_path__ + "src/assets/img/spotlight_dark_300.f61cb20b.png";